import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c685a3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c685a3b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c685a3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c685a3b')) {
      api.createRecord('0c685a3b', component.options)
    } else {
      api.reload('0c685a3b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c685a3b&scoped=true", function () {
      api.rerender('0c685a3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/EasyTag/index.vue"
export default component.exports